import Vue from 'vue';
import findIndex from 'lodash/findIndex';

const compareModule = {
  namespaced: true,
  state: {
    racks: {},
  },

  mutations: {
    addItem(state, {unitId, item}) {
      state.racks[unitId].push(item);
    },

    addRack(state, unitId) {
      Vue.set(state.racks, unitId, []);
    },

    removeItem(state, {unitId, itemIndex}) {
      state.racks[unitId].splice(itemIndex, 1);
    },

    emptyRackItems(state, unitId) {
      state.racks[unitId] = [];
    }
  },

  actions: {
    addToRack({commit, rootGetters, state}, item) {
      const unitId = rootGetters.unitId;
      if (state.racks[unitId]) {
        commit('addItem', {unitId: unitId, item});
      } else {
        commit('addRack', unitId);
        commit('addItem', {unitId: unitId, item});
      }

      toast({
        type: 'success',
        message: 'Item added',
      });
    },

    
    createRack({commit, rootGetters, state}) {
      const unitId = rootGetters.unitId;
      if (!state.racks[unitId]) {
        commit('addRack', unitId);
      }
    },

    removeFromRack({commit, rootGetters, state}, item) {
      const unitId = rootGetters.unitId;
      const itemIndex = findIndex(state.racks[unitId], {productCode: item.productCode});
      if (itemIndex > -1) {
        commit('removeItem', {unitId, itemIndex});
        toast({
          type: 'success',
          message: 'Item removed',
        });
      }
    },

    emptyRack({commit, rootGetters}) {
      const unitId = rootGetters.unitId;
      commit('emptyRackItems', unitId);
      toast({
        type: 'success',
        message: 'Compare rack emptied',
      });
    },
  },

  getters: {
    currentRack(state, getters, rootState, rootGetters) {
      return state.racks[rootGetters.unitId];
    },
  },
};

export default compareModule;
